import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-heart-red",
  "use": "icon-heart-red-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol viewBox=\"0 0 22 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-heart-red\">\n<path d=\"M10.8124 20C11.0526 20 11.4188 19.8398 11.6819 19.6682C17.7574 15.7666 21.6362 11.2243 21.6362 6.61327C21.6362 2.73455 18.9588 0 15.4348 0C13.4096 0 11.7963 0.949657 10.8124 2.40275C9.85126 0.961099 8.2151 0 6.18993 0C2.6659 0 0 2.73455 0 6.61327C0 11.2243 3.86728 15.7666 9.94279 19.6682C10.2174 19.8398 10.5721 20 10.8124 20Z\" fill=\"#F84D5F\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol